import { getFunnelReport } from "@ts/funnel";

async function loadCharts() {
    await getFunnelReport();
}

export { loadCharts };
